// @ts-nocheck
/**
 * 装備レシピ定義
 *
 * 設計書 crafting_system_design.md v0.5 に準拠
 *
 * 装備タイプ:
 * - weapon: 武器（攻撃力重視）
 * - armor: 防具（防御・HP重視）
 * - accessory: アクセサリ（特殊効果重視）
 * - special: 特殊装備（ユニーク効果）
 *
 * ティア:
 * - common: 一般的な装備（外縁部10-20F）
 * - uncommon: やや良い装備（浅層部21-40F）
 * - rare: レア装備（中層部41-60F）
 * - epic: エピック装備（深部61-80F）
 * - legendary: 伝説装備（最深部81F+）
 */

// ========================================
// 1. チュートリアル装備（4種）
// 最初に作る装備。素材は「魔力の核」だけで作れる。
// ========================================

export const TUTORIAL_EQUIPMENT = {
  apprentice_sword: {
    id: 'apprentice_sword',
    name: '見習いの剣',
    type: 'weapon',
    tier: 'common',
    description: '最初に作る基本的な剣。',
    materials: [
      { type: '魔力の核', count: 20 },
    ],
    baseStats: {
      attack: 100,
    },
    effects: [],
  },

  apprentice_armor: {
    id: 'apprentice_armor',
    name: '見習いの鎧',
    type: 'armor',
    tier: 'common',
    description: '最初に作る基本的な鎧。',
    materials: [
      { type: '魔力の核', count: 20 },
    ],
    baseStats: {
      hp: 300,
    },
    effects: [],
  },

  apprentice_bracelet: {
    id: 'apprentice_bracelet',
    name: '見習いの腕輪',
    type: 'accessory',
    tier: 'common',
    description: '最初に作る基本的な腕輪。',
    materials: [
      { type: '魔力の核', count: 20 },
    ],
    baseStats: {
      speed: 5,
    },
    effects: [],
  },

  adventurer_handbook: {
    id: 'adventurer_handbook',
    name: '冒険者の手帳',
    type: 'special',
    tier: 'common',
    description: '経験値獲得量が増加する手帳。',
    materials: [
      { type: '魔力の核', count: 20 },
    ],
    baseStats: {},
    effects: [
      { type: 'exp_boost', bonus: 0.1 },
    ],
  },
};

// ========================================
// 2. 属性系装備 - 属性耐性（6種・防具・Rare）
// 弱点属性の素材で対策装備を作る（水で炎耐性など）
// ========================================

export const ATTRIBUTE_RESISTANCE = {
  fire_shield: {
    id: 'fire_shield',
    name: '炎避けの盾',
    type: 'armor',
    tier: 'rare',
    description: '炎属性のダメージを軽減する盾。',
    materials: [
      { type: '水の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_resistance', attribute: '炎', value: 0.35 },
    ],
  },

  water_shield: {
    id: 'water_shield',
    name: '水避けの盾',
    type: 'armor',
    tier: 'rare',
    description: '水属性のダメージを軽減する盾。',
    materials: [
      { type: '炎の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_resistance', attribute: '水', value: 0.35 },
    ],
  },

  light_shield: {
    id: 'light_shield',
    name: '光避けの盾',
    type: 'armor',
    tier: 'rare',
    description: '光属性のダメージを軽減する盾。',
    materials: [
      { type: '闇の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_resistance', attribute: '光', value: 0.35 },
    ],
  },

  dark_shield: {
    id: 'dark_shield',
    name: '闇避けの盾',
    type: 'armor',
    tier: 'rare',
    description: '闇属性のダメージを軽減する盾。',
    materials: [
      { type: '光の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_resistance', attribute: '闇', value: 0.35 },
    ],
  },

  primitive_shield: {
    id: 'primitive_shield',
    name: '原始避けの盾',
    type: 'armor',
    tier: 'rare',
    description: '原始属性のダメージを軽減する盾。',
    materials: [
      { type: '未来の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_resistance', attribute: '原始', value: 0.35 },
    ],
  },

  future_shield: {
    id: 'future_shield',
    name: '未来避けの盾',
    type: 'armor',
    tier: 'rare',
    description: '未来属性のダメージを軽減する盾。',
    materials: [
      { type: '原始の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_resistance', attribute: '未来', value: 0.35 },
    ],
  },
};

// ========================================
// 2. 属性系装備 - 属性特攻（6種・武器・Rare）
// ========================================

export const ATTRIBUTE_SLAYER = {
  fire_slayer: {
    id: 'fire_slayer',
    name: '炎殺しの剣',
    type: 'weapon',
    tier: 'rare',
    description: '炎属性の敵に大ダメージを与える剣。',
    materials: [
      { type: '水の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_killer', attribute: '炎', value: 0.40 },
    ],
  },

  water_slayer: {
    id: 'water_slayer',
    name: '水殺しの剣',
    type: 'weapon',
    tier: 'rare',
    description: '水属性の敵に大ダメージを与える剣。',
    materials: [
      { type: '炎の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_killer', attribute: '水', value: 0.40 },
    ],
  },

  light_slayer: {
    id: 'light_slayer',
    name: '光殺しの剣',
    type: 'weapon',
    tier: 'rare',
    description: '光属性の敵に大ダメージを与える剣。',
    materials: [
      { type: '闇の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_killer', attribute: '光', value: 0.40 },
    ],
  },

  dark_slayer: {
    id: 'dark_slayer',
    name: '闇殺しの剣',
    type: 'weapon',
    tier: 'rare',
    description: '闇属性の敵に大ダメージを与える剣。',
    materials: [
      { type: '光の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_killer', attribute: '闇', value: 0.40 },
    ],
  },

  primitive_slayer: {
    id: 'primitive_slayer',
    name: '原始殺しの剣',
    type: 'weapon',
    tier: 'rare',
    description: '原始属性の敵に大ダメージを与える剣。',
    materials: [
      { type: '未来の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_killer', attribute: '原始', value: 0.40 },
    ],
  },

  future_slayer: {
    id: 'future_slayer',
    name: '未来殺しの剣',
    type: 'weapon',
    tier: 'rare',
    description: '未来属性の敵に大ダメージを与える剣。',
    materials: [
      { type: '原始の結晶', count: 80 },
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_killer', attribute: '未来', value: 0.40 },
    ],
  },
};

// ========================================
// 2. 属性系装備 - 属性強化（6種・アクセ・Rare）
// ========================================

export const ATTRIBUTE_RINGS = {
  fire_ring: {
    id: 'fire_ring',
    name: '炎のリング',
    type: 'accessory',
    tier: 'rare',
    description: '炎属性のダメージを強化するリング。',
    materials: [
      { type: '炎の結晶', count: 100 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '炎', value: 0.25 },
    ],
  },

  water_ring: {
    id: 'water_ring',
    name: '水のリング',
    type: 'accessory',
    tier: 'rare',
    description: '水属性のダメージを強化するリング。',
    materials: [
      { type: '水の結晶', count: 100 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '水', value: 0.25 },
    ],
  },

  light_ring: {
    id: 'light_ring',
    name: '光のリング',
    type: 'accessory',
    tier: 'rare',
    description: '光属性のダメージを強化するリング。',
    materials: [
      { type: '光の結晶', count: 100 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '光', value: 0.25 },
    ],
  },

  dark_ring: {
    id: 'dark_ring',
    name: '闇のリング',
    type: 'accessory',
    tier: 'rare',
    description: '闇属性のダメージを強化するリング。',
    materials: [
      { type: '闇の結晶', count: 100 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '闇', value: 0.25 },
    ],
  },

  primitive_ring: {
    id: 'primitive_ring',
    name: '原始のリング',
    type: 'accessory',
    tier: 'rare',
    description: '原始属性のダメージを強化するリング。',
    materials: [
      { type: '原始の結晶', count: 100 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '原始', value: 0.25 },
    ],
  },

  future_ring: {
    id: 'future_ring',
    name: '未来のリング',
    type: 'accessory',
    tier: 'rare',
    description: '未来属性のダメージを強化するリング。',
    materials: [
      { type: '未来の結晶', count: 100 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '未来', value: 0.25 },
    ],
  },
};

// ========================================
// 2. 属性系装備 - 属性エンブレム（6種・アクセ・Epic）
// 上位版。属性特化ビルドの完成形。
// ========================================

export const ATTRIBUTE_EMBLEMS = {
  fire_emblem: {
    id: 'fire_emblem',
    name: '炎のエンブレム',
    type: 'accessory',
    tier: 'epic',
    description: '炎属性のダメージと耐性を大幅に強化するエンブレム。',
    materials: [
      { type: '炎の結晶', count: 200 },
      { type: '不死鳥の炎羽', count: 20 },
      { type: 'HR破片', count: 10 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '炎', value: 0.40 },
      { type: 'attribute_resistance', attribute: '炎', value: 0.20 },
    ],
  },

  water_emblem: {
    id: 'water_emblem',
    name: '水のエンブレム',
    type: 'accessory',
    tier: 'epic',
    description: '水属性のダメージと耐性を大幅に強化するエンブレム。',
    materials: [
      { type: '水の結晶', count: 200 },
      { type: '海神の涙', count: 20 },
      { type: 'HR破片', count: 10 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '水', value: 0.40 },
      { type: 'attribute_resistance', attribute: '水', value: 0.20 },
    ],
  },

  light_emblem: {
    id: 'light_emblem',
    name: '光のエンブレム',
    type: 'accessory',
    tier: 'epic',
    description: '光属性のダメージと耐性を大幅に強化するエンブレム。',
    materials: [
      { type: '光の結晶', count: 200 },
      { type: '聖女の祈り', count: 20 },
      { type: 'HR破片', count: 10 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '光', value: 0.40 },
      { type: 'attribute_resistance', attribute: '光', value: 0.20 },
    ],
  },

  dark_emblem: {
    id: 'dark_emblem',
    name: '闇のエンブレム',
    type: 'accessory',
    tier: 'epic',
    description: '闇属性のダメージと耐性を大幅に強化するエンブレム。',
    materials: [
      { type: '闇の結晶', count: 200 },
      { type: '深淵の核', count: 20 },
      { type: 'HR破片', count: 10 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '闇', value: 0.40 },
      { type: 'attribute_resistance', attribute: '闇', value: 0.20 },
    ],
  },

  primitive_emblem: {
    id: 'primitive_emblem',
    name: '原始のエンブレム',
    type: 'accessory',
    tier: 'epic',
    description: '原始属性のダメージと耐性を大幅に強化するエンブレム。',
    materials: [
      { type: '原始の結晶', count: 200 },
      { type: '獣王の牙', count: 20 },
      { type: 'HR破片', count: 10 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '原始', value: 0.40 },
      { type: 'attribute_resistance', attribute: '原始', value: 0.20 },
    ],
  },

  future_emblem: {
    id: 'future_emblem',
    name: '未来のエンブレム',
    type: 'accessory',
    tier: 'epic',
    description: '未来属性のダメージと耐性を大幅に強化するエンブレム。',
    materials: [
      { type: '未来の結晶', count: 200 },
      { type: '次元の鍵', count: 10 },
      { type: 'HR破片', count: 10 },
    ],
    baseStats: {},
    effects: [
      { type: 'attribute_damage_boost', attribute: '未来', value: 0.40 },
      { type: 'attribute_resistance', attribute: '未来', value: 0.20 },
    ],
  },
};

// ========================================
// 3. カテゴリ系装備 - 種族系強化（13種・特殊・Rare）
// ノーマル素材で作成。
// ========================================

export const RACE_EQUIPMENT = {
  dragon_crest: {
    id: 'dragon_crest',
    name: '竜の紋章',
    type: 'special',
    tier: 'rare',
    description: 'ドラゴン系モンスターの能力を強化する紋章。',
    materials: [
      { type: '竜鱗', count: 40 },
      { type: '炎の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'ドラゴン系', value: 0.25 },
    ],
  },

  beast_necklace: {
    id: 'beast_necklace',
    name: '獣の首飾り',
    type: 'special',
    tier: 'rare',
    description: 'ビースト系モンスターの能力を強化する首飾り。',
    materials: [
      { type: '獣の牙', count: 50 },
      { type: '原始の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'ビースト系', value: 0.25 },
    ],
  },

  spirit_lantern: {
    id: 'spirit_lantern',
    name: '霊魂の灯火',
    type: 'special',
    tier: 'rare',
    description: 'スピリット系モンスターの能力を強化する灯火。',
    materials: [
      { type: '霊魂のエーテル', count: 40 },
      { type: '闇の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'スピリット', value: 0.25 },
    ],
  },

  wing_ornament: {
    id: 'wing_ornament',
    name: '翼の羽飾り',
    type: 'special',
    tier: 'rare',
    description: '鳥系モンスターの能力を強化する羽飾り。',
    materials: [
      { type: '風切り羽', count: 40 },
      { type: '光の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '鳥系', value: 0.25 },
    ],
  },

  rock_heart_amulet: {
    id: 'rock_heart_amulet',
    name: '岩心の護符',
    type: 'special',
    tier: 'rare',
    description: 'ゴーレム系モンスターの能力を強化する護符。',
    materials: [
      { type: '魔力のコア', count: 40 },
      { type: '原始の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'ゴーレム系', value: 0.25 },
    ],
  },

  life_seedling: {
    id: 'life_seedling',
    name: '生命の苗',
    type: 'special',
    tier: 'rare',
    description: 'プラント系モンスターの能力を強化する苗。',
    materials: [
      { type: '生命の種子', count: 40 },
      { type: '水の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'プラント系', value: 0.25 },
    ],
  },

  slime_core_pendant: {
    id: 'slime_core_pendant',
    name: '粘液核のペンダント',
    type: 'special',
    tier: 'rare',
    description: 'スライム系モンスターの能力を強化するペンダント。',
    materials: [
      { type: '粘液核', count: 50 },
      { type: '水の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'スライム系', value: 0.25 },
    ],
  },

  insect_shell_ornament: {
    id: 'insect_shell_ornament',
    name: '虫の甲殻飾り',
    type: 'special',
    tier: 'rare',
    description: '虫類モンスターの能力を強化する飾り。',
    materials: [
      { type: '虫殻の欠片', count: 50 },
      { type: '原始の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '虫類', value: 0.25 },
    ],
  },

  machine_heart: {
    id: 'machine_heart',
    name: '機械の心臓',
    type: 'special',
    tier: 'rare',
    description: '機械系モンスターの能力を強化する心臓。',
    materials: [
      { type: '機械部品', count: 50 },
      { type: '未来の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '機械', value: 0.25 },
    ],
  },

  magic_tome: {
    id: 'magic_tome',
    name: '魔導の書',
    type: 'special',
    tier: 'rare',
    description: '魔法生物の能力を強化する書物。',
    materials: [
      { type: '魔力結晶', count: 40 },
      { type: '闇の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '魔法生物', value: 0.25 },
    ],
  },

  grudge_amulet: {
    id: 'grudge_amulet',
    name: '怨念の護符',
    type: 'special',
    tier: 'rare',
    description: '霊体モンスターの能力を強化する護符。',
    materials: [
      { type: '怨念の残滓', count: 40 },
      { type: '闇の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '霊体', value: 0.25 },
    ],
  },

  snakeskin_bracelet: {
    id: 'snakeskin_bracelet',
    name: '蛇皮の腕輪',
    type: 'special',
    tier: 'rare',
    description: '爬虫類モンスターの能力を強化する腕輪。',
    materials: [
      { type: '蛇皮', count: 40 },
      { type: '原始の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '爬虫類', value: 0.25 },
    ],
  },

  humanoid_badge: {
    id: 'humanoid_badge',
    name: '人型の証章',
    type: 'special',
    tier: 'rare',
    description: 'ヒューマノイドモンスターの能力を強化する証章。',
    materials: [
      { type: '人型の証', count: 50 },
      { type: '魔力の核', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'ヒューマノイド', value: 0.25 },
    ],
  },
};

// ========================================
// 3. カテゴリ系装備 - 種族系強化・上位（13種・特殊・Epic）
// レア素材で作成。
// ========================================

export const RACE_EQUIPMENT_UPPER = {
  dragon_king_crest: {
    id: 'dragon_king_crest',
    name: '竜王の紋章',
    type: 'special',
    tier: 'epic',
    description: 'ドラゴン系モンスターの能力を大幅に強化する紋章。',
    materials: [
      { type: '竜王の逆鱗', count: 15 },
      { type: '竜鱗', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'ドラゴン系', value: 0.40 },
      { type: 'attribute_resistance', attribute: '炎', value: 0.20 },
    ],
  },

  beast_king_necklace: {
    id: 'beast_king_necklace',
    name: '獣王の首飾り',
    type: 'special',
    tier: 'epic',
    description: 'ビースト系モンスターの能力を大幅に強化する首飾り。',
    materials: [
      { type: '獣王の牙', count: 15 },
      { type: '獣の牙', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'ビースト系', value: 0.40 },
      { type: 'critical_boost', value: 0.15 },
    ],
  },

  spirit_king_lantern: {
    id: 'spirit_king_lantern',
    name: '精霊王の灯火',
    type: 'special',
    tier: 'epic',
    description: 'スピリット系モンスターの能力を大幅に強化する灯火。',
    materials: [
      { type: '精霊王の涙', count: 10 },
      { type: '霊魂のエーテル', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'スピリット', value: 0.40 },
      { type: 'evasion', bonus: 0.15 },
    ],
  },

  skysoar_ornament: {
    id: 'skysoar_ornament',
    name: '天翔の羽飾り',
    type: 'special',
    tier: 'epic',
    description: '鳥系モンスターの能力を大幅に強化する羽飾り。',
    materials: [
      { type: '天翔の羽根', count: 15 },
      { type: '風切り羽', count: 30 },
    ],
    baseStats: {
      speed: 20,
    },
    effects: [
      { type: 'category_boost', category: '鳥系', value: 0.40 },
    ],
  },

  ancient_core_amulet: {
    id: 'ancient_core_amulet',
    name: '古代核の護符',
    type: 'special',
    tier: 'epic',
    description: 'ゴーレム系モンスターの能力を大幅に強化する護符。',
    materials: [
      { type: '古代のコア', count: 10 },
      { type: '魔力のコア', count: 30 },
    ],
    baseStats: {
      hp: 1000,
    },
    effects: [
      { type: 'category_boost', category: 'ゴーレム系', value: 0.40 },
    ],
  },

  world_tree_seedling: {
    id: 'world_tree_seedling',
    name: '世界樹の苗',
    type: 'special',
    tier: 'epic',
    description: 'プラント系モンスターの能力を大幅に強化する苗。',
    materials: [
      { type: '世界樹の雫', count: 10 },
      { type: '生命の種子', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'プラント系', value: 0.40 },
      { type: 'heal_boost', value: 0.25 },
    ],
  },

  king_core_pendant: {
    id: 'king_core_pendant',
    name: '王核のペンダント',
    type: 'special',
    tier: 'epic',
    description: 'スライム系モンスターの能力を大幅に強化するペンダント。',
    materials: [
      { type: '王核スライム', count: 10 },
      { type: '粘液核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'スライム系', value: 0.40 },
      { type: 'split_chance', value: 0.15 },
    ],
  },

  queen_ant_shell: {
    id: 'queen_ant_shell',
    name: '女王蟻の甲殻',
    type: 'special',
    tier: 'epic',
    description: '虫類モンスターの能力を大幅に強化する甲殻。',
    materials: [
      { type: '女王蟻の触角', count: 10 },
      { type: '虫殻の欠片', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '虫類', value: 0.40 },
      { type: 'poison_inflict', value: 0.20 },
    ],
  },

  energy_core_heart: {
    id: 'energy_core_heart',
    name: 'エネルギーコアの心臓',
    type: 'special',
    tier: 'epic',
    description: '機械系モンスターの能力を大幅に強化する心臓。',
    materials: [
      { type: 'エネルギーコア', count: 10 },
      { type: '機械部品', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '機械', value: 0.40 },
      { type: 'cooldown_reduction', value: 1 },
    ],
  },

  demon_king_tome: {
    id: 'demon_king_tome',
    name: '魔王の書',
    type: 'special',
    tier: 'epic',
    description: '魔法生物の能力を大幅に強化する書物。',
    materials: [
      { type: '魔王の角', count: 10 },
      { type: '魔力結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '魔法生物', value: 0.40 },
      { type: 'skill_damage', value: 0.20 },
    ],
  },

  netherworld_amulet: {
    id: 'netherworld_amulet',
    name: '冥界の護符',
    type: 'special',
    tier: 'epic',
    description: '霊体モンスターの能力を大幅に強化する護符。',
    materials: [
      { type: '冥界の灯火', count: 10 },
      { type: '怨念の残滓', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '霊体', value: 0.40 },
      { type: 'instant_death_resistance', value: 0.50 },
    ],
  },

  snake_king_bracelet: {
    id: 'snake_king_bracelet',
    name: '蛇王の腕輪',
    type: 'special',
    tier: 'epic',
    description: '爬虫類モンスターの能力を大幅に強化する腕輪。',
    materials: [
      { type: '蛇王の牙', count: 8 },
      { type: '蛇皮', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: '爬虫類', value: 0.40 },
      { type: 'paralyze_inflict', value: 0.20 },
    ],
  },

  hero_badge: {
    id: 'hero_badge',
    name: '英雄の証章',
    type: 'special',
    tier: 'epic',
    description: 'ヒューマノイドモンスターの能力を大幅に強化する証章。',
    materials: [
      { type: '英雄の魂', count: 10 },
      { type: '人型の証', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'category_boost', category: 'ヒューマノイド', value: 0.40 },
      { type: 'all_stats', value: 0.10 },
    ],
  },
};

// ========================================
// 3-3. 派閥系強化装備（15種・アクセ・Rare）
// 派閥グループ専用のアクセサリー装備。
// ========================================

export const FACTION_EQUIPMENT = {
  curse_bracelet: {
    id: 'curse_bracelet',
    name: '呪縛の腕輪',
    type: 'accessory',
    tier: 'rare',
    description: 'ソウルカースモンスターの能力を強化する腕輪。',
    materials: [
      { type: '呪縛の鎖', count: 40 },
      { type: '闇の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'ソウルカース', value: 0.25 },
    ],
  },

  tide_ring: {
    id: 'tide_ring',
    name: '潮流の指輪',
    type: 'accessory',
    tier: 'rare',
    description: 'タイドウェーブモンスターの能力を強化する指輪。',
    materials: [
      { type: '潮流の結晶', count: 40 },
      { type: '水の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'タイドウェーブ', value: 0.25 },
    ],
  },

  puppet_gloves: {
    id: 'puppet_gloves',
    name: '操糸の手袋',
    type: 'accessory',
    tier: 'rare',
    description: 'パペットマスターモンスターの能力を強化する手袋。',
    materials: [
      { type: '操糸', count: 40 },
      { type: '闇の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'パペットマスター', value: 0.25 },
    ],
  },

  deep_dark_ring: {
    id: 'deep_dark_ring',
    name: '深闇のリング',
    type: 'accessory',
    tier: 'rare',
    description: 'ダークドウェラモンスターの能力を強化するリング。',
    materials: [
      { type: '深闇の欠片', count: 40 },
      { type: '闇の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'ダークドウェラ', value: 0.25 },
    ],
  },

  lava_ring: {
    id: 'lava_ring',
    name: '溶岩のリング',
    type: 'accessory',
    tier: 'rare',
    description: 'マグマフォージモンスターの能力を強化するリング。',
    materials: [
      { type: '溶岩核', count: 40 },
      { type: '炎の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'マグマフォージ', value: 0.25 },
    ],
  },

  savage_bracelet: {
    id: 'savage_bracelet',
    name: '蛮勇の腕輪',
    type: 'accessory',
    tier: 'rare',
    description: '蛮族モンスターの能力を強化する腕輪。',
    materials: [
      { type: '蛮勇の証', count: 40 },
      { type: '原始の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '蛮族', value: 0.25 },
    ],
  },

  time_gear_ornament: {
    id: 'time_gear_ornament',
    name: '時の歯車飾り',
    type: 'accessory',
    tier: 'rare',
    description: 'エクラシアモンスターの能力を強化する飾り。',
    materials: [
      { type: '時の歯車', count: 40 },
      { type: '未来の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'エクラシア', value: 0.25 },
    ],
  },

  sky_feather_ornament: {
    id: 'sky_feather_ornament',
    name: '天空の羽飾り',
    type: 'accessory',
    tier: 'rare',
    description: '飛翔連合モンスターの能力を強化する羽飾り。',
    materials: [
      { type: '天空の羽根', count: 40 },
      { type: '光の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '飛翔連合', value: 0.25 },
    ],
  },

  abyss_eye: {
    id: 'abyss_eye',
    name: '深淵の眼',
    type: 'accessory',
    tier: 'rare',
    description: '深淵勢力モンスターの能力を強化する眼。',
    materials: [
      { type: '深淵の闘気', count: 40 },
      { type: '闇の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '深淵勢力', value: 0.25 },
    ],
  },

  void_fragment_ornament: {
    id: 'void_fragment_ornament',
    name: '虚無の欠片飾り',
    type: 'accessory',
    tier: 'rare',
    description: '虚蝕モンスターの能力を強化する飾り。',
    materials: [
      { type: '虚無の欠片', count: 40 },
      { type: '闇の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '虚蝕', value: 0.25 },
    ],
  },

  holy_light_ring: {
    id: 'holy_light_ring',
    name: '聖光のリング',
    type: 'accessory',
    tier: 'rare',
    description: '聖光モンスターの能力を強化するリング。',
    materials: [
      { type: '聖光の結晶', count: 40 },
      { type: '光の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '聖光', value: 0.25 },
    ],
  },

  spacetime_hourglass: {
    id: 'spacetime_hourglass',
    name: '時空の砂時計',
    type: 'accessory',
    tier: 'rare',
    description: '時空モンスターの能力を強化する砂時計。',
    materials: [
      { type: '時空の砂', count: 40 },
      { type: '未来の結晶', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '時空', value: 0.25 },
    ],
  },

  poison_fang_ring: {
    id: 'poison_fang_ring',
    name: '毒牙の指輪',
    type: 'accessory',
    tier: 'rare',
    description: '毒牙モンスターの能力を強化する指輪。',
    materials: [
      { type: '毒腺', count: 40 },
      { type: '原始の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '毒牙', value: 0.25 },
    ],
  },

  chain_bracelet: {
    id: 'chain_bracelet',
    name: '鎖の腕輪',
    type: 'accessory',
    tier: 'rare',
    description: '拘束モンスターの能力を強化する腕輪。',
    materials: [
      { type: '鎖の欠片', count: 40 },
      { type: '闇の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '拘束', value: 0.25 },
    ],
  },

  fighting_spirit_ring: {
    id: 'fighting_spirit_ring',
    name: '闘志の指輪',
    type: 'accessory',
    tier: 'rare',
    description: '宿敵モンスターの能力を強化する指輪。',
    materials: [
      { type: '闘志の欠片', count: 40 },
      { type: '炎の結晶', count: 40 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '宿敵', value: 0.25 },
    ],
  },
};

// ========================================
// 3-4. 派閥系強化装備・上位（15種・アクセ・Epic）
// 派閥グループ専用の上位アクセサリー装備。
// ========================================

export const FACTION_EQUIPMENT_UPPER = {
  soul_eater_bracelet: {
    id: 'soul_eater_bracelet',
    name: '魂喰いの腕輪',
    type: 'accessory',
    tier: 'epic',
    description: 'ソウルカースモンスターの能力を大幅に強化する腕輪。',
    materials: [
      { type: '魂喰いの鎖', count: 15 },
      { type: '呪縛の鎖', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'ソウルカース', value: 0.40 },
      { type: 'hp_drain', value: 0.15 },
    ],
  },

  sea_god_ring: {
    id: 'sea_god_ring',
    name: '海神の指輪',
    type: 'accessory',
    tier: 'epic',
    description: 'タイドウェーブモンスターの能力を大幅に強化する指輪。',
    materials: [
      { type: '海神の涙', count: 10 },
      { type: '潮流の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'タイドウェーブ', value: 0.40 },
      { type: 'attribute_resistance', attribute: '水', value: 0.25 },
    ],
  },

  puppeteer_gloves: {
    id: 'puppeteer_gloves',
    name: '傀儡師の手袋',
    type: 'accessory',
    tier: 'epic',
    description: 'パペットマスターモンスターの能力を大幅に強化する手袋。',
    materials: [
      { type: '傀儡師の心臓', count: 10 },
      { type: '操糸', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'パペットマスター', value: 0.40 },
      { type: 'control_success', value: 0.20 },
    ],
  },

  abyss_core_ring: {
    id: 'abyss_core_ring',
    name: '深淵核のリング',
    type: 'accessory',
    tier: 'epic',
    description: 'ダークドウェラモンスターの能力を大幅に強化するリング。',
    materials: [
      { type: '深淵の核', count: 10 },
      { type: '深闇の欠片', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'ダークドウェラ', value: 0.40 },
      { type: 'attribute_resistance', attribute: '闇', value: 0.25 },
    ],
  },

  furnace_core_ring: {
    id: 'furnace_core_ring',
    name: '炉心のリング',
    type: 'accessory',
    tier: 'epic',
    description: 'マグマフォージモンスターの能力を大幅に強化するリング。',
    materials: [
      { type: '炉心の結晶', count: 10 },
      { type: '溶岩核', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'マグマフォージ', value: 0.40 },
      { type: 'burn_inflict', value: 0.20 },
    ],
  },

  chieftain_bracelet: {
    id: 'chieftain_bracelet',
    name: '族長の腕輪',
    type: 'accessory',
    tier: 'epic',
    description: '蛮族モンスターの能力を大幅に強化する腕輪。',
    materials: [
      { type: '族長の魂', count: 10 },
      { type: '蛮勇の証', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '蛮族', value: 0.40 },
      { type: 'atk_percent', value: 0.15 },
    ],
  },

  eternal_gear_ornament: {
    id: 'eternal_gear_ornament',
    name: '永劫の歯車飾り',
    type: 'accessory',
    tier: 'epic',
    description: 'エクラシアモンスターの能力を大幅に強化する飾り。',
    materials: [
      { type: '永劫の砂', count: 10 },
      { type: '時の歯車', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: 'エクラシア', value: 0.40 },
      { type: 'cooldown_reduction', value: 1 },
    ],
  },

  azure_feather_ornament: {
    id: 'azure_feather_ornament',
    name: '蒼天の羽飾り',
    type: 'accessory',
    tier: 'epic',
    description: '飛翔連合モンスターの能力を大幅に強化する羽飾り。',
    materials: [
      { type: '蒼天の冠羽', count: 10 },
      { type: '天空の羽根', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '飛翔連合', value: 0.40 },
      { type: 'preemptive_chance', value: 0.30 },
    ],
  },

  void_heart: {
    id: 'void_heart',
    name: '虚無の心臓',
    type: 'accessory',
    tier: 'epic',
    description: '深淵勢力モンスターの能力を大幅に強化する心臓。',
    materials: [
      { type: '虚無の心臓', count: 10 },
      { type: '深淵の闘気', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '深淵勢力', value: 0.40 },
      { type: 'instant_death_inflict', value: 0.10 },
    ],
  },

  erosion_core_ornament: {
    id: 'erosion_core_ornament',
    name: '侵蝕核の飾り',
    type: 'accessory',
    tier: 'epic',
    description: '虚蝕モンスターの能力を大幅に強化する飾り。',
    materials: [
      { type: '侵蝕の核', count: 10 },
      { type: '虚無の欠片', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '虚蝕', value: 0.40 },
      { type: 'debuff_power', value: 0.25 },
    ],
  },

  saint_prayer_ring: {
    id: 'saint_prayer_ring',
    name: '聖女の祈りリング',
    type: 'accessory',
    tier: 'epic',
    description: '聖光モンスターの能力を大幅に強化するリング。',
    materials: [
      { type: '聖女の祈り', count: 10 },
      { type: '聖光の結晶', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '聖光', value: 0.40 },
      { type: 'heal_boost', value: 0.30 },
    ],
  },

  dimensional_key_clock: {
    id: 'dimensional_key_clock',
    name: '次元の鍵時計',
    type: 'accessory',
    tier: 'epic',
    description: '時空モンスターの能力を大幅に強化する時計。',
    materials: [
      { type: '次元の鍵', count: 10 },
      { type: '時空の砂', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '時空', value: 0.40 },
      { type: 'evasion', value: 0.20 },
    ],
  },

  deadly_poison_ring: {
    id: 'deadly_poison_ring',
    name: '猛毒の指輪',
    type: 'accessory',
    tier: 'epic',
    description: '毒牙モンスターの能力を大幅に強化する指輪。',
    materials: [
      { type: '猛毒の心臓', count: 10 },
      { type: '毒腺', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '毒牙', value: 0.40 },
      { type: 'poison_damage', value: 0.50 },
    ],
  },

  seal_bracelet: {
    id: 'seal_bracelet',
    name: '封印の腕輪',
    type: 'accessory',
    tier: 'epic',
    description: '拘束モンスターの能力を大幅に強化する腕輪。',
    materials: [
      { type: '封印の鎖', count: 10 },
      { type: '鎖の欠片', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '拘束', value: 0.40 },
      { type: 'stun_chance', value: 0.15 },
    ],
  },

  destiny_ring: {
    id: 'destiny_ring',
    name: '宿命の指輪',
    type: 'accessory',
    tier: 'epic',
    description: '宿敵モンスターの能力を大幅に強化する指輪。',
    materials: [
      { type: '宿命の証', count: 10 },
      { type: '闘志の欠片', count: 30 },
    ],
    baseStats: {},
    effects: [
      { type: 'faction_boost', faction: '宿敵', value: 0.40 },
      { type: 'critical', value: 0.20 },
    ],
  },
};

// ========================================
// 4. 汎用装備 - 武器（ATK特化）（4種）
// どのカードにも装備できる基本装備。
// ========================================

export const GENERIC_WEAPONS = {
  iron_sword: {
    id: 'iron_sword',
    name: '鉄の剣',
    type: 'weapon',
    tier: 'common',
    description: '基本的な鉄製の剣。',
    materials: [
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {
      attack: 150,
    },
    effects: [],
  },

  steel_sword: {
    id: 'steel_sword',
    name: '鋼の剣',
    type: 'weapon',
    tier: 'rare',
    description: '鋼で鍛えられた頑丈な剣。',
    materials: [
      { type: '魔力の核', count: 80 },
      { type: 'R破片', count: 10 },
    ],
    baseStats: {
      attack: 400,
    },
    effects: [],
  },

  magic_sword: {
    id: 'magic_sword',
    name: '魔剣',
    type: 'weapon',
    tier: 'epic',
    description: '魔力が込められた強力な剣。',
    materials: [
      { type: '秘宝の欠片', count: 15 },
      { type: 'UR破片', count: 15 },
    ],
    baseStats: {
      attack: 800,
    },
    effects: [],
  },

  emperor_sword: {
    id: 'emperor_sword',
    name: '覇王の剣',
    type: 'weapon',
    tier: 'legendary',
    description: '覇王の力が宿る伝説の剣。',
    materials: [
      { type: '原初の結晶', count: 3 },
      { type: 'GR破片', count: 20 },
    ],
    baseStats: {
      attack: 1400,
    },
    effects: [],
  },
};

// ========================================
// 4. 汎用装備 - 防具（HP特化）（4種）
// ========================================

export const GENERIC_ARMORS = {
  iron_armor: {
    id: 'iron_armor',
    name: '鉄の鎧',
    type: 'armor',
    tier: 'common',
    description: '基本的な鉄製の鎧。',
    materials: [
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {
      hp: 400,
    },
    effects: [],
  },

  steel_armor: {
    id: 'steel_armor',
    name: '鋼の鎧',
    type: 'armor',
    tier: 'rare',
    description: '鋼で鍛えられた頑丈な鎧。',
    materials: [
      { type: '魔力の核', count: 80 },
      { type: 'R破片', count: 10 },
    ],
    baseStats: {
      hp: 1000,
    },
    effects: [],
  },

  magic_armor: {
    id: 'magic_armor',
    name: '魔鎧',
    type: 'armor',
    tier: 'epic',
    description: '魔力が込められた強力な鎧。',
    materials: [
      { type: '秘宝の欠片', count: 15 },
      { type: 'UR破片', count: 15 },
    ],
    baseStats: {
      hp: 1800,
    },
    effects: [],
  },

  emperor_armor: {
    id: 'emperor_armor',
    name: '覇王の鎧',
    type: 'armor',
    tier: 'legendary',
    description: '覇王の力が宿る伝説の鎧。',
    materials: [
      { type: '原初の結晶', count: 3 },
      { type: 'GR破片', count: 20 },
    ],
    baseStats: {
      hp: 3000,
    },
    effects: [],
  },
};

// ========================================
// 4. 汎用装備 - アクセサリ（速度特化）（4種）
// ========================================

export const GENERIC_ACCESSORIES = {
  swift_boots: {
    id: 'swift_boots',
    name: '速足の靴',
    type: 'accessory',
    tier: 'common',
    description: '軽快な足取りを可能にする靴。',
    materials: [
      { type: '魔力の核', count: 30 },
    ],
    baseStats: {
      speed: 8,
    },
    effects: [],
  },

  gale_boots: {
    id: 'gale_boots',
    name: '疾風の靴',
    type: 'accessory',
    tier: 'rare',
    description: '風のように素早く動ける靴。',
    materials: [
      { type: '魔力の核', count: 80 },
      { type: 'R破片', count: 10 },
    ],
    baseStats: {
      speed: 20,
    },
    effects: [],
  },

  godspeed_boots: {
    id: 'godspeed_boots',
    name: '神速の靴',
    type: 'accessory',
    tier: 'epic',
    description: '神の如き速さを得られる靴。',
    materials: [
      { type: '秘宝の欠片', count: 15 },
      { type: 'UR破片', count: 15 },
    ],
    baseStats: {
      speed: 35,
    },
    effects: [
      { type: 'evasion', bonus: 0.1 },
    ],
  },

  emperor_boots: {
    id: 'emperor_boots',
    name: '覇王の靴',
    type: 'accessory',
    tier: 'legendary',
    description: '覇王の力が宿る伝説の靴。',
    materials: [
      { type: '原初の結晶', count: 3 },
      { type: 'GR破片', count: 20 },
    ],
    baseStats: {
      speed: 50,
    },
    effects: [
      { type: 'guaranteed_first', value: true },
    ],
  },
};

// ========================================
// 4. 汎用装備 - 特殊（周回系）（4種）
// ========================================

export const GENERIC_SPECIALS = {
  exp_charm: {
    id: 'exp_charm',
    name: '経験のお守り',
    type: 'special',
    tier: 'uncommon',
    description: '経験値獲得量が増加するお守り。',
    materials: [
      { type: '炎の結晶', count: 10 },
      { type: '水の結晶', count: 10 },
      { type: '光の結晶', count: 10 },
      { type: '闇の結晶', count: 10 },
      { type: '原始の結晶', count: 10 },
      { type: '未来の結晶', count: 10 },
      { type: '魔力の核', count: 20 },
    ],
    baseStats: {},
    effects: [
      { type: 'exp_boost', bonus: 0.15 },
    ],
  },

  lucky_coin: {
    id: 'lucky_coin',
    name: '幸運のコイン',
    type: 'special',
    tier: 'rare',
    description: 'ドロップ率が上昇する幸運のコイン。',
    materials: [
      { type: '秘宝の欠片', count: 15 },
    ],
    baseStats: {},
    effects: [
      { type: 'drop_rate_boost', bonus: 0.2 },
    ],
  },

  fortune_wallet: {
    id: 'fortune_wallet',
    name: '金運の財布',
    type: 'special',
    tier: 'rare',
    description: 'ゴールド獲得量が増加する財布。',
    materials: [
      { type: '秘宝の欠片', count: 10 },
      { type: '魔力の核', count: 50 },
    ],
    baseStats: {},
    effects: [
      { type: 'gold_boost', bonus: 0.25 },
    ],
  },

  explorer_glasses: {
    id: 'explorer_glasses',
    name: '探索者の眼鏡',
    type: 'special',
    tier: 'rare',
    description: '宝箱発見率が上昇する眼鏡。',
    materials: [
      { type: '記憶の結晶', count: 10 },
    ],
    baseStats: {},
    effects: [
      { type: 'treasure_find_boost', bonus: 0.3 },
    ],
  },
};

// ========================================
// セット効果定義
// ========================================

export const SET_BONUSES = {
  dragon_set: {
    name: 'ドラゴンセット',
    description: '竜の力を宿した装備セット',
    bonuses: {
      2: {
        type: 'category_boost',
        category: 'ドラゴン系',
        value: 0.15,
        description: 'ドラゴン系+15%',
      },
      3: {
        type: 'category_boost',
        category: 'ドラゴン系',
        value: 0.30,
        description: 'ドラゴン系+30%, 開幕手札にドラゴン確定',
      },
    },
  },

  sea_god_set: {
    name: '海神セット',
    description: '海神の祝福を受けた装備セット',
    bonuses: {
      2: {
        type: 'hp_percent',
        value: 0.2,
        description: 'HP+20%',
      },
      3: {
        type: 'heal_boost',
        value: 0.3,
        description: '回復効果+30%',
      },
    },
  },

  forbidden_set: {
    name: '禁忌セット',
    description: '禁忌の力を纏う装備セット',
    bonuses: {
      2: {
        type: 'skill_damage',
        value: 0.3,
        description: 'スキルダメージ+30%',
      },
      3: {
        type: 'forbidden_power',
        value: true,
        description: '禁忌コスト-2, 毎ターン敵全体ダメージ',
      },
    },
  },
};

// ========================================
// 統合エクスポート
// ========================================

/**
 * 全レシピを統合
 */
export const RECIPES = {
  // チュートリアル装備
  ...TUTORIAL_EQUIPMENT,

  // 属性系装備
  ...ATTRIBUTE_RESISTANCE,
  ...ATTRIBUTE_SLAYER,
  ...ATTRIBUTE_RINGS,
  ...ATTRIBUTE_EMBLEMS,

  // 種族系装備
  ...RACE_EQUIPMENT,
  ...RACE_EQUIPMENT_UPPER,

  // 派閥系装備
  ...FACTION_EQUIPMENT,
  ...FACTION_EQUIPMENT_UPPER,

  // 汎用装備
  ...GENERIC_WEAPONS,
  ...GENERIC_ARMORS,
  ...GENERIC_ACCESSORIES,
  ...GENERIC_SPECIALS,
};

/**
 * レシピIDからレシピを取得
 *
 * @param {string} recipeId - レシピID
 * @returns {Object|null} レシピ
 */
export function getRecipe(recipeId) {
  return RECIPES[recipeId] || null;
}

/**
 * タイプ別にレシピを取得
 *
 * @param {string} type - 装備タイプ ('weapon' | 'armor' | 'accessory' | 'special')
 * @returns {Object[]} レシピ配列
 */
export function getRecipesByType(type) {
  return Object.values(RECIPES).filter(recipe => recipe.type === type);
}

/**
 * ティア別にレシピを取得
 *
 * @param {string} tier - ティア ('common' | 'uncommon' | 'rare' | 'epic' | 'legendary')
 * @returns {Object[]} レシピ配列
 */
export function getRecipesByTier(tier) {
  return Object.values(RECIPES).filter(recipe => recipe.tier === tier);
}

/**
 * セットIDからレシピを取得
 *
 * @param {string} setId - セットID
 * @returns {Object[]} レシピ配列
 */
export function getRecipesBySet(setId) {
  return Object.values(RECIPES).filter(recipe => recipe.setId === setId);
}

/**
 * セット効果を取得
 *
 * @param {string} setId - セットID
 * @returns {Object|null} セット効果
 */
export function getSetBonus(setId) {
  return SET_BONUSES[setId] || null;
}

/**
 * 特定の素材を使用するレシピを取得
 *
 * @param {string} materialType - 素材タイプ
 * @returns {Object[]} レシピ配列
 */
export function getRecipesUsingMaterial(materialType) {
  return Object.values(RECIPES).filter(recipe =>
    recipe.materials.some(mat => mat.type === materialType)
  );
}

export default {
  RECIPES,
  SET_BONUSES,
  TUTORIAL_EQUIPMENT,
  ATTRIBUTE_RESISTANCE,
  ATTRIBUTE_SLAYER,
  ATTRIBUTE_RINGS,
  ATTRIBUTE_EMBLEMS,
  RACE_EQUIPMENT,
  RACE_EQUIPMENT_UPPER,
  FACTION_EQUIPMENT,
  FACTION_EQUIPMENT_UPPER,
  GENERIC_WEAPONS,
  GENERIC_ARMORS,
  GENERIC_ACCESSORIES,
  GENERIC_SPECIALS,
  getRecipe,
  getRecipesByType,
  getRecipesByTier,
  getRecipesBySet,
  getSetBonus,
  getRecipesUsingMaterial,
};
